import { Link } from 'react-router-dom';
import { PLAYER_BASE_URL } from '../../apiConfig';
import playerImgDefault from '../../images/player.png';
import { Plane, Home } from 'lucide-react';
import { motion } from 'framer-motion';

function PlayerCard({ data, teamId }) {
    const isMobile = window.innerWidth <= 768;

    const styles = {
        card: {
            width: '100%',
            height: '100%',
            flex: 1,
            minHeight: isMobile ? '270px' : '350px',
            background: 'linear-gradient(180deg, #0812BB 0%, #000443 100%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: isMobile ? '12px' : '16px',
            boxSizing: 'border-box',
            textDecoration: 'none',
            borderRadius: '0px',
            border: '1px solid rgba(255,255,255,0.1)',
            position: 'relative',
            overflow: 'hidden',
        },
        badgeRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            position: 'absolute',
            top: '12px',
            left: '0',
            padding: '0 12px',
            boxSizing: 'border-box',
            zIndex: 10,
        },
        captainPill: {
            background: '#FFFFFF',
            borderRadius: '50%',
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
        },
        overseasIcon: {
            color: '#FFFFFF',
            opacity: 0.9,
        },
        imgContainer: {
            width: '100%',
            height: isMobile ? '165px' : '220px',
            borderRadius: '16px',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            marginTop: isMobile ? '28px' : '36px', 
            marginBottom: '12px',
            border: '1px solid rgba(255,255,255,0.15)',
            boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
            background: 'rgba(0,0,0,0.2)',
        },
        playerImage: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'top center',
        },
        infoBox: {
            width: '100%',
            marginTop: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
        },
        playerName: {
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: isMobile ? '16px' : '24px',
            fontWeight: 700,
            color: '#FFFFFF',
            margin: 0,
            textTransform: 'uppercase',
            letterSpacing: isMobile ? '0.5px' : '0%',
            lineHeight: isMobile ? '1.1' : '100%',
        },
        playerRole: {
            fontFamily: 'var(--fontInter)',
            fontWeight: 500,
            fontSize: isMobile ? '11px' : '13px',
            color: 'rgba(255,255,255,0.7)',
            margin: '4px 0 0 0',
            textTransform: 'capitalize',
        },
        playerIdText: {
            fontFamily: 'var(--fontInter)',
            fontWeight: 700,
            fontSize: isMobile ? '11px' : '12px',
            color: '#FFFFFF',
            background: 'rgba(255, 255, 255, 0.15)',
            padding: '2px 6px',
            borderRadius: '4px',
            letterSpacing: '0.5px',
            border: '1px solid rgba(255, 255, 255, 0.2)',
        }
    };

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const isOverseas = data.player_type?.toLowerCase().includes('overseas');
    const isHome = data.player_type?.toLowerCase().includes('home');
    const isCaptain = data.Captain === 1 || data.is_captain === 1;
    const isVerified = data.documentVerification == 1;
    const iconColor = isVerified ? '#2ECC71' : '#E7C424';

    return (
        <motion.div
            whileHover={{ y: -8, boxShadow: '0 12px 30px rgba(0,0,0,0.4)' }}
            style={{ display: 'contents' }}
        >
            <Link
                to={"/player-profile/" + data.PlayerID}
                state={teamId}
                style={styles.card}
                onClick={handleScrollToTop}
            >
                {/* Status Badges */}
                <div style={styles.badgeRow}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {isCaptain && (
                            <div style={styles.captainPill} title="Captain">
                                <span style={{ color: '#060D8A', fontSize: '18px', fontWeight: 900, fontFamily: 'var(--fontAnton)' }}>C</span>
                            </div>
                        )}
                        {data.PlayerID && (
                            <div style={styles.playerIdText}>#{data.PlayerID}</div>
                        )}
                    </div>
                    
                    <div style={styles.overseasIcon}>
                        {isOverseas && (
                            <div title="Overseas Player">
                                <Plane size={22} color={iconColor} />
                            </div>
                        )}
                        {isHome && (
                            <div title="Home Player">
                                <Home size={22} color={iconColor} />
                            </div>
                        )}
                    </div>
                </div>

                {/* Player Cutout */}
                <div style={styles.imgContainer}>
                    <img 
                        src={data.Photo ? `${PLAYER_BASE_URL}/${data.Photo}` : playerImgDefault} 
                        alt={data.Forename} 
                        style={styles.playerImage} 
                    />
                </div>

                {/* Info */}
                <div style={styles.infoBox}>
                    <h3 style={styles.playerName}>{data.Forename} {data.Surname}</h3>
                    <p style={styles.playerRole}>{data.player_spec || 'Batter'}</p>
                </div>
            </Link>
        </motion.div>
    );
}

export default PlayerCard;